var map = {
	"./accountSection__profileImage--dark.png": 1022,
	"./accountSection__profileImage.png": 1023,
	"./accountSection__settings--dark.png": 1024,
	"./accountSection__settings.png": 1025,
	"./accountSection__settingsClose--dark.png": 1026,
	"./accountSection__settingsClose.png": 1027,
	"./appIcon.png": 1028,
	"./app_buttons/button__appStore.svg": 1029,
	"./app_buttons/button__googlePlay.svg": 1030,
	"./athletes/1.png": 1031,
	"./athletes/100.png": 1032,
	"./athletes/1004.png": 1033,
	"./athletes/1014.png": 1034,
	"./athletes/104.png": 1035,
	"./athletes/107.png": 1036,
	"./athletes/1075.png": 1037,
	"./athletes/1078.png": 1038,
	"./athletes/1079.png": 1039,
	"./athletes/1081.png": 1040,
	"./athletes/1086.png": 1041,
	"./athletes/1088.png": 1042,
	"./athletes/110.png": 1043,
	"./athletes/1105.png": 1044,
	"./athletes/115.png": 1045,
	"./athletes/1168.png": 1046,
	"./athletes/1169.png": 1047,
	"./athletes/1172.png": 1048,
	"./athletes/1180.png": 1049,
	"./athletes/1202.png": 1050,
	"./athletes/1211.png": 1051,
	"./athletes/122.png": 1052,
	"./athletes/123.png": 1053,
	"./athletes/126.png": 1054,
	"./athletes/129.png": 1055,
	"./athletes/130.png": 1056,
	"./athletes/1306.png": 1057,
	"./athletes/1313.png": 1058,
	"./athletes/1317.png": 1059,
	"./athletes/1319.png": 1060,
	"./athletes/1320.png": 1061,
	"./athletes/1324.png": 1062,
	"./athletes/1328.png": 1063,
	"./athletes/1332.png": 1064,
	"./athletes/1339.png": 1065,
	"./athletes/134.png": 1066,
	"./athletes/1343.png": 1067,
	"./athletes/1345.png": 1068,
	"./athletes/1346.png": 1069,
	"./athletes/1347.png": 1070,
	"./athletes/1350.png": 1071,
	"./athletes/1358.png": 1072,
	"./athletes/1359.png": 1073,
	"./athletes/1360.png": 1074,
	"./athletes/1364.png": 1075,
	"./athletes/1375.png": 1076,
	"./athletes/1377.png": 1077,
	"./athletes/138.png": 1078,
	"./athletes/1382.png": 1079,
	"./athletes/1383.png": 1080,
	"./athletes/1388.png": 1081,
	"./athletes/139.png": 1082,
	"./athletes/1397.png": 1083,
	"./athletes/14.png": 1084,
	"./athletes/1401.png": 1085,
	"./athletes/1402.png": 1086,
	"./athletes/1403.png": 1087,
	"./athletes/1404.png": 1088,
	"./athletes/1405.png": 1089,
	"./athletes/1418.png": 1090,
	"./athletes/142.png": 1091,
	"./athletes/1424.png": 1092,
	"./athletes/1425.png": 1093,
	"./athletes/143.png": 1094,
	"./athletes/1430.png": 1095,
	"./athletes/1435.png": 1096,
	"./athletes/1441.png": 1097,
	"./athletes/1443.png": 1098,
	"./athletes/1447.png": 1099,
	"./athletes/1451.png": 1100,
	"./athletes/1454.png": 1101,
	"./athletes/1458.png": 1102,
	"./athletes/1459.png": 1103,
	"./athletes/146.png": 1104,
	"./athletes/1463.png": 1105,
	"./athletes/1466.png": 1106,
	"./athletes/1473.png": 1107,
	"./athletes/1475.png": 1108,
	"./athletes/1476.png": 1109,
	"./athletes/1481.png": 1110,
	"./athletes/1491.png": 1111,
	"./athletes/1493.png": 1112,
	"./athletes/1504.png": 1113,
	"./athletes/1513.png": 1114,
	"./athletes/1515.png": 1115,
	"./athletes/1520.png": 1116,
	"./athletes/1524.png": 1117,
	"./athletes/1525.png": 1118,
	"./athletes/1539.png": 1119,
	"./athletes/154.png": 1120,
	"./athletes/1540.png": 1121,
	"./athletes/1543.png": 1122,
	"./athletes/1547.png": 1123,
	"./athletes/1553.png": 1124,
	"./athletes/1554.png": 1125,
	"./athletes/1557.png": 1126,
	"./athletes/1564.png": 1127,
	"./athletes/1566.png": 1128,
	"./athletes/1567.png": 1129,
	"./athletes/1568.png": 1130,
	"./athletes/157.png": 1131,
	"./athletes/1570.png": 1132,
	"./athletes/1578.png": 1133,
	"./athletes/1580.png": 1134,
	"./athletes/1582.png": 1135,
	"./athletes/1585.png": 1136,
	"./athletes/1587.png": 1137,
	"./athletes/1593.png": 1138,
	"./athletes/1594.png": 1139,
	"./athletes/16.png": 1140,
	"./athletes/1601.png": 1141,
	"./athletes/1602.png": 1142,
	"./athletes/1604.png": 1143,
	"./athletes/1609.png": 1144,
	"./athletes/161.png": 1145,
	"./athletes/1611.png": 1146,
	"./athletes/1615.png": 1147,
	"./athletes/1618.png": 1148,
	"./athletes/1619.png": 1149,
	"./athletes/1621.png": 1150,
	"./athletes/1622.png": 1151,
	"./athletes/1627.png": 1152,
	"./athletes/1628.png": 1153,
	"./athletes/1629.png": 1154,
	"./athletes/1632.png": 1155,
	"./athletes/1641.png": 1156,
	"./athletes/1642.png": 1157,
	"./athletes/1644.png": 1158,
	"./athletes/1648.png": 1159,
	"./athletes/1650.png": 1160,
	"./athletes/1653.png": 1161,
	"./athletes/1655.png": 1162,
	"./athletes/1656.png": 1163,
	"./athletes/1657.png": 1164,
	"./athletes/1658.png": 1165,
	"./athletes/1659.png": 1166,
	"./athletes/1660.png": 1167,
	"./athletes/1663.png": 1168,
	"./athletes/1665.png": 1169,
	"./athletes/1666.png": 1170,
	"./athletes/1670.png": 1171,
	"./athletes/1671.png": 1172,
	"./athletes/1673.png": 1173,
	"./athletes/1674.png": 1174,
	"./athletes/1675.png": 1175,
	"./athletes/1677.png": 1176,
	"./athletes/1678.png": 1177,
	"./athletes/1679.png": 1178,
	"./athletes/1680.png": 1179,
	"./athletes/1681.png": 1180,
	"./athletes/1682.png": 1181,
	"./athletes/1684.png": 1182,
	"./athletes/1687.png": 1183,
	"./athletes/1688.png": 1184,
	"./athletes/1694.png": 1185,
	"./athletes/1698.png": 1186,
	"./athletes/1701.png": 1187,
	"./athletes/1704.png": 1188,
	"./athletes/1705.png": 1189,
	"./athletes/1710.png": 1190,
	"./athletes/1711.png": 1191,
	"./athletes/1713.png": 1192,
	"./athletes/1714.png": 1193,
	"./athletes/1730.png": 1194,
	"./athletes/1731.png": 1195,
	"./athletes/1738.png": 1196,
	"./athletes/1743.png": 1197,
	"./athletes/1744.png": 1198,
	"./athletes/1748.png": 1199,
	"./athletes/1750.png": 1200,
	"./athletes/1751.png": 1201,
	"./athletes/1752.png": 1202,
	"./athletes/1753.png": 1203,
	"./athletes/1755.png": 1204,
	"./athletes/1759.png": 1205,
	"./athletes/1760.png": 1206,
	"./athletes/1761.png": 1207,
	"./athletes/1762.png": 1208,
	"./athletes/1763.png": 1209,
	"./athletes/1764.png": 1210,
	"./athletes/1765.png": 1211,
	"./athletes/1766.png": 1212,
	"./athletes/1768.png": 1213,
	"./athletes/1771.png": 1214,
	"./athletes/1772.png": 1215,
	"./athletes/1773.png": 1216,
	"./athletes/1774.png": 1217,
	"./athletes/1779.png": 1218,
	"./athletes/1781.png": 1219,
	"./athletes/1785.png": 1220,
	"./athletes/1789.png": 1221,
	"./athletes/1790.png": 1222,
	"./athletes/1792.png": 1223,
	"./athletes/1795.png": 1224,
	"./athletes/1796.png": 1225,
	"./athletes/1797.png": 1226,
	"./athletes/1799.png": 1227,
	"./athletes/1804.png": 1228,
	"./athletes/1808.png": 1229,
	"./athletes/1809.png": 1230,
	"./athletes/1810.png": 1231,
	"./athletes/1811.png": 1232,
	"./athletes/1820.png": 1233,
	"./athletes/1821.png": 1234,
	"./athletes/1822.png": 1235,
	"./athletes/1823.png": 1236,
	"./athletes/1825.png": 1237,
	"./athletes/1846.png": 1238,
	"./athletes/1850.png": 1239,
	"./athletes/1852.png": 1240,
	"./athletes/1856.png": 1241,
	"./athletes/1857.png": 1242,
	"./athletes/1863.png": 1243,
	"./athletes/1868.png": 1244,
	"./athletes/1874.png": 1245,
	"./athletes/1875.png": 1246,
	"./athletes/1880.png": 1247,
	"./athletes/1881.png": 1248,
	"./athletes/1882.png": 1249,
	"./athletes/1887.png": 1250,
	"./athletes/1890.png": 1251,
	"./athletes/1892.png": 1252,
	"./athletes/1896.png": 1253,
	"./athletes/1897.png": 1254,
	"./athletes/1899.png": 1255,
	"./athletes/1901.png": 1256,
	"./athletes/1903.png": 1257,
	"./athletes/1904.png": 1258,
	"./athletes/1905.png": 1259,
	"./athletes/1906.png": 1260,
	"./athletes/1917.png": 1261,
	"./athletes/197.png": 1262,
	"./athletes/1976.png": 1263,
	"./athletes/1979.png": 1264,
	"./athletes/1982.png": 1265,
	"./athletes/1983.png": 1266,
	"./athletes/1985.png": 1267,
	"./athletes/1991.png": 1268,
	"./athletes/1993.png": 1269,
	"./athletes/1998.png": 1270,
	"./athletes/2019.png": 1271,
	"./athletes/202.png": 1272,
	"./athletes/2020.png": 1273,
	"./athletes/2022.png": 1274,
	"./athletes/2023.png": 1275,
	"./athletes/2024.png": 1276,
	"./athletes/2028.png": 1277,
	"./athletes/2029.png": 1278,
	"./athletes/2030.png": 1279,
	"./athletes/206.png": 1280,
	"./athletes/2090.png": 1281,
	"./athletes/2095.png": 1282,
	"./athletes/2098.png": 1283,
	"./athletes/2105.png": 1284,
	"./athletes/2106.png": 1285,
	"./athletes/2107.png": 1286,
	"./athletes/2112.png": 1287,
	"./athletes/2113.png": 1288,
	"./athletes/2115.png": 1289,
	"./athletes/2116.png": 1290,
	"./athletes/2117.png": 1291,
	"./athletes/2119.png": 1292,
	"./athletes/2121.png": 1293,
	"./athletes/2125.png": 1294,
	"./athletes/2126.png": 1295,
	"./athletes/2131.png": 1296,
	"./athletes/2132.png": 1297,
	"./athletes/2133.png": 1298,
	"./athletes/2136.png": 1299,
	"./athletes/2140.png": 1300,
	"./athletes/2142.png": 1301,
	"./athletes/2149.png": 1302,
	"./athletes/2172.png": 1303,
	"./athletes/2174.png": 1304,
	"./athletes/2186.png": 1305,
	"./athletes/2189.png": 1306,
	"./athletes/2191.png": 1307,
	"./athletes/2193.png": 1308,
	"./athletes/2194.png": 1309,
	"./athletes/2198.png": 1310,
	"./athletes/2199.png": 1311,
	"./athletes/22.png": 1312,
	"./athletes/2201.png": 1313,
	"./athletes/2202.png": 1314,
	"./athletes/2204.png": 1315,
	"./athletes/2206.png": 1316,
	"./athletes/2207.png": 1317,
	"./athletes/2209.png": 1318,
	"./athletes/2212.png": 1319,
	"./athletes/2213.png": 1320,
	"./athletes/2216.png": 1321,
	"./athletes/2238.png": 1322,
	"./athletes/2239.png": 1323,
	"./athletes/2283.png": 1324,
	"./athletes/23.png": 1325,
	"./athletes/235.png": 1326,
	"./athletes/2351.png": 1327,
	"./athletes/2364.png": 1328,
	"./athletes/2366.png": 1329,
	"./athletes/2367.png": 1330,
	"./athletes/2384.png": 1331,
	"./athletes/2387.png": 1332,
	"./athletes/2389.png": 1333,
	"./athletes/2400.png": 1334,
	"./athletes/2411.png": 1335,
	"./athletes/2412.png": 1336,
	"./athletes/2420.png": 1337,
	"./athletes/2423.png": 1338,
	"./athletes/2425.png": 1339,
	"./athletes/2426.png": 1340,
	"./athletes/2461.png": 1341,
	"./athletes/2463.png": 1342,
	"./athletes/2468.png": 1343,
	"./athletes/2470.png": 1344,
	"./athletes/2473.png": 1345,
	"./athletes/2478.png": 1346,
	"./athletes/2489.png": 1347,
	"./athletes/2491.png": 1348,
	"./athletes/2492.png": 1349,
	"./athletes/25.png": 1350,
	"./athletes/250.png": 1351,
	"./athletes/2500.png": 1352,
	"./athletes/2501.png": 1353,
	"./athletes/2504.png": 1354,
	"./athletes/2510.png": 1355,
	"./athletes/252.png": 1356,
	"./athletes/2520.png": 1357,
	"./athletes/2521.png": 1358,
	"./athletes/2530.png": 1359,
	"./athletes/255.png": 1360,
	"./athletes/2586.png": 1361,
	"./athletes/2593.png": 1362,
	"./athletes/2596.png": 1363,
	"./athletes/2598.png": 1364,
	"./athletes/2605.png": 1365,
	"./athletes/2616.png": 1366,
	"./athletes/2631.png": 1367,
	"./athletes/2636.png": 1368,
	"./athletes/268.png": 1369,
	"./athletes/2689.png": 1370,
	"./athletes/27.png": 1371,
	"./athletes/274.png": 1372,
	"./athletes/2749.png": 1373,
	"./athletes/2754.png": 1374,
	"./athletes/2761.png": 1375,
	"./athletes/2774.png": 1376,
	"./athletes/2785.png": 1377,
	"./athletes/2786.png": 1378,
	"./athletes/2787.png": 1379,
	"./athletes/2791.png": 1380,
	"./athletes/2798.png": 1381,
	"./athletes/2799.png": 1382,
	"./athletes/2801.png": 1383,
	"./athletes/2802.png": 1384,
	"./athletes/2803.png": 1385,
	"./athletes/2804.png": 1386,
	"./athletes/2806.png": 1387,
	"./athletes/2808.png": 1388,
	"./athletes/2809.png": 1389,
	"./athletes/2810.png": 1390,
	"./athletes/2812.png": 1391,
	"./athletes/2813.png": 1392,
	"./athletes/2815.png": 1393,
	"./athletes/2816.png": 1394,
	"./athletes/2817.png": 1395,
	"./athletes/2820.png": 1396,
	"./athletes/2821.png": 1397,
	"./athletes/2822.png": 1398,
	"./athletes/2828.png": 1399,
	"./athletes/2829.png": 1400,
	"./athletes/2830.png": 1401,
	"./athletes/2831.png": 1402,
	"./athletes/2833.png": 1403,
	"./athletes/2834.png": 1404,
	"./athletes/2835.png": 1405,
	"./athletes/2839.png": 1406,
	"./athletes/2842.png": 1407,
	"./athletes/2844.png": 1408,
	"./athletes/2851.png": 1409,
	"./athletes/2853.png": 1410,
	"./athletes/2858.png": 1411,
	"./athletes/2864.png": 1412,
	"./athletes/2868.png": 1413,
	"./athletes/2874.png": 1414,
	"./athletes/2877.png": 1415,
	"./athletes/2881.png": 1416,
	"./athletes/2888.png": 1417,
	"./athletes/2894.png": 1418,
	"./athletes/2900.png": 1419,
	"./athletes/2901.png": 1420,
	"./athletes/291.png": 1421,
	"./athletes/2914.png": 1422,
	"./athletes/2916.png": 1423,
	"./athletes/303.png": 1424,
	"./athletes/3072.png": 1425,
	"./athletes/3073.png": 1426,
	"./athletes/3106.png": 1427,
	"./athletes/3122.png": 1428,
	"./athletes/3128.png": 1429,
	"./athletes/3139.png": 1430,
	"./athletes/3199.png": 1431,
	"./athletes/3203.png": 1432,
	"./athletes/3204.png": 1433,
	"./athletes/3275.png": 1434,
	"./athletes/3307.png": 1435,
	"./athletes/3329.png": 1436,
	"./athletes/3330.png": 1437,
	"./athletes/3337.png": 1438,
	"./athletes/3341.png": 1439,
	"./athletes/3342.png": 1440,
	"./athletes/3385.png": 1441,
	"./athletes/3389.png": 1442,
	"./athletes/3390.png": 1443,
	"./athletes/3391.png": 1444,
	"./athletes/3396.png": 1445,
	"./athletes/3398.png": 1446,
	"./athletes/3401.png": 1447,
	"./athletes/3405.png": 1448,
	"./athletes/3406.png": 1449,
	"./athletes/3407.png": 1450,
	"./athletes/3408.png": 1451,
	"./athletes/3409.png": 1452,
	"./athletes/3410.png": 1453,
	"./athletes/3411.png": 1454,
	"./athletes/3412.png": 1455,
	"./athletes/3413.png": 1456,
	"./athletes/3414.png": 1457,
	"./athletes/3417.png": 1458,
	"./athletes/3418.png": 1459,
	"./athletes/3419.png": 1460,
	"./athletes/3422.png": 1461,
	"./athletes/3424.png": 1462,
	"./athletes/3425.png": 1463,
	"./athletes/3426.png": 1464,
	"./athletes/3427.png": 1465,
	"./athletes/3428.png": 1466,
	"./athletes/3429.png": 1467,
	"./athletes/3430.png": 1468,
	"./athletes/3431.png": 1469,
	"./athletes/3432.png": 1470,
	"./athletes/3434.png": 1471,
	"./athletes/3442.png": 1472,
	"./athletes/3443.png": 1473,
	"./athletes/3444.png": 1474,
	"./athletes/3445.png": 1475,
	"./athletes/3446.png": 1476,
	"./athletes/3458.png": 1477,
	"./athletes/3461.png": 1478,
	"./athletes/3463.png": 1479,
	"./athletes/3466.png": 1480,
	"./athletes/3468.png": 1481,
	"./athletes/3472.png": 1482,
	"./athletes/3505.png": 1483,
	"./athletes/3506.png": 1484,
	"./athletes/3514.png": 1485,
	"./athletes/3516.png": 1486,
	"./athletes/3517.png": 1487,
	"./athletes/3518.png": 1488,
	"./athletes/3519.png": 1489,
	"./athletes/3520.png": 1490,
	"./athletes/3521.png": 1491,
	"./athletes/3523.png": 1492,
	"./athletes/3524.png": 1493,
	"./athletes/3526.png": 1494,
	"./athletes/3527.png": 1495,
	"./athletes/3528.png": 1496,
	"./athletes/3529.png": 1497,
	"./athletes/3530.png": 1498,
	"./athletes/3531.png": 1499,
	"./athletes/3532.png": 1500,
	"./athletes/3533.png": 1501,
	"./athletes/3535.png": 1502,
	"./athletes/3536.png": 1503,
	"./athletes/3537.png": 1504,
	"./athletes/3540.png": 1505,
	"./athletes/3542.png": 1506,
	"./athletes/3544.png": 1507,
	"./athletes/3545.png": 1508,
	"./athletes/3546.png": 1509,
	"./athletes/3547.png": 1510,
	"./athletes/3548.png": 1511,
	"./athletes/3549.png": 1512,
	"./athletes/3550.png": 1513,
	"./athletes/3551.png": 1514,
	"./athletes/3552.png": 1515,
	"./athletes/3553.png": 1516,
	"./athletes/3554.png": 1517,
	"./athletes/3555.png": 1518,
	"./athletes/3556.png": 1519,
	"./athletes/3557.png": 1520,
	"./athletes/3558.png": 1521,
	"./athletes/3559.png": 1522,
	"./athletes/3560.png": 1523,
	"./athletes/3561.png": 1524,
	"./athletes/3562.png": 1525,
	"./athletes/3563.png": 1526,
	"./athletes/3564.png": 1527,
	"./athletes/3565.png": 1528,
	"./athletes/3566.png": 1529,
	"./athletes/3567.png": 1530,
	"./athletes/3568.png": 1531,
	"./athletes/3569.png": 1532,
	"./athletes/3570.png": 1533,
	"./athletes/3572.png": 1534,
	"./athletes/3573.png": 1535,
	"./athletes/3574.png": 1536,
	"./athletes/3575.png": 1537,
	"./athletes/3576.png": 1538,
	"./athletes/3577.png": 1539,
	"./athletes/3578.png": 1540,
	"./athletes/3579.png": 1541,
	"./athletes/3580.png": 1542,
	"./athletes/3581.png": 1543,
	"./athletes/3582.png": 1544,
	"./athletes/3583.png": 1545,
	"./athletes/3584.png": 1546,
	"./athletes/3585.png": 1547,
	"./athletes/3586.png": 1548,
	"./athletes/3587.png": 1549,
	"./athletes/3588.png": 1550,
	"./athletes/3589.png": 1551,
	"./athletes/3590.png": 1552,
	"./athletes/3591.png": 1553,
	"./athletes/3592.png": 1554,
	"./athletes/3593.png": 1555,
	"./athletes/3594.png": 1556,
	"./athletes/3595.png": 1557,
	"./athletes/3596.png": 1558,
	"./athletes/3597.png": 1559,
	"./athletes/3598.png": 1560,
	"./athletes/3599.png": 1561,
	"./athletes/3600.png": 1562,
	"./athletes/3695.png": 1563,
	"./athletes/3704.png": 1564,
	"./athletes/373.png": 1565,
	"./athletes/3851.png": 1566,
	"./athletes/3870.png": 1567,
	"./athletes/4.png": 1568,
	"./athletes/4140.png": 1569,
	"./athletes/4142.png": 1570,
	"./athletes/416.png": 1571,
	"./athletes/419.png": 1572,
	"./athletes/426.png": 1573,
	"./athletes/442.png": 1574,
	"./athletes/478.png": 1575,
	"./athletes/485.png": 1576,
	"./athletes/486.png": 1577,
	"./athletes/487.png": 1578,
	"./athletes/488.png": 1579,
	"./athletes/493.png": 1580,
	"./athletes/497.png": 1581,
	"./athletes/499.png": 1582,
	"./athletes/50.png": 1583,
	"./athletes/500.png": 1584,
	"./athletes/503.png": 1585,
	"./athletes/505.png": 1586,
	"./athletes/506.png": 1587,
	"./athletes/507.png": 1588,
	"./athletes/512.png": 1589,
	"./athletes/513.png": 1590,
	"./athletes/516.png": 1591,
	"./athletes/52.png": 1592,
	"./athletes/521.png": 1593,
	"./athletes/527.png": 1594,
	"./athletes/528.png": 1595,
	"./athletes/531.png": 1596,
	"./athletes/538.png": 1597,
	"./athletes/539.png": 1598,
	"./athletes/542.png": 1599,
	"./athletes/546.png": 1600,
	"./athletes/547.png": 1601,
	"./athletes/551.png": 1602,
	"./athletes/57.png": 1603,
	"./athletes/59.png": 1604,
	"./athletes/595.png": 1605,
	"./athletes/597.png": 1606,
	"./athletes/599.png": 1607,
	"./athletes/603.png": 1608,
	"./athletes/604.png": 1609,
	"./athletes/63.png": 1610,
	"./athletes/640.png": 1611,
	"./athletes/648.png": 1612,
	"./athletes/656.png": 1613,
	"./athletes/66.png": 1614,
	"./athletes/68.png": 1615,
	"./athletes/735.png": 1616,
	"./athletes/80.png": 1617,
	"./athletes/83.png": 1618,
	"./athletes/88.png": 1619,
	"./athletes/882.png": 1620,
	"./athletes/885.png": 1621,
	"./athletes/901.png": 1622,
	"./athletes/909.png": 1623,
	"./athletes/92.png": 1624,
	"./athletes/927.png": 1625,
	"./athletes/928.png": 1626,
	"./athletes/931.png": 1627,
	"./athletes/932.png": 1628,
	"./athletes/933.png": 1629,
	"./athletes/990.png": 1630,
	"./athletes/992.png": 1631,
	"./athletes/995.png": 1632,
	"./athletes/996.png": 1633,
	"./athletes/998.png": 1634,
	"./athletes/default.png": 1635,
	"./bet__correctMarker.png": 1636,
	"./bet__wrongMarker.png": 1637,
	"./bonusForSharing__bg.jpg": 1638,
	"./championship__iconChangeTeam.png": 1639,
	"./championship__iconCorrect.png": 1640,
	"./championship__iconDown.png": 1641,
	"./championship__iconPickTeam--plain.png": 1642,
	"./championship__iconPickTeam.png": 1643,
	"./championship__iconUp.png": 1644,
	"./championship__iconWrong.png": 1645,
	"./community__tease__deco--desktop.png": 1646,
	"./community__tease__deco--mobile.png": 1647,
	"./dailySpecialMarker.png": 1648,
	"./del_fantasy_logo.png": 1649,
	"./del_logo.svg": 1650,
	"./expert__selectedArrow--dark.png": 1651,
	"./expert__selectedArrow.png": 1652,
	"./flags/AD.svg": 347,
	"./flags/AE.svg": 348,
	"./flags/AF.svg": 349,
	"./flags/AG.svg": 350,
	"./flags/AI.svg": 351,
	"./flags/AL.svg": 352,
	"./flags/AM.svg": 353,
	"./flags/AO.svg": 354,
	"./flags/AR.svg": 355,
	"./flags/AS.svg": 356,
	"./flags/AT.svg": 357,
	"./flags/AU.svg": 358,
	"./flags/AW.svg": 359,
	"./flags/AX.svg": 360,
	"./flags/AZ.svg": 361,
	"./flags/BA.svg": 362,
	"./flags/BB.svg": 363,
	"./flags/BD.svg": 364,
	"./flags/BE.svg": 365,
	"./flags/BF.svg": 366,
	"./flags/BG.svg": 367,
	"./flags/BH.svg": 368,
	"./flags/BI.svg": 369,
	"./flags/BJ.svg": 370,
	"./flags/BL.svg": 371,
	"./flags/BM.svg": 372,
	"./flags/BN.svg": 373,
	"./flags/BO.svg": 374,
	"./flags/BR.svg": 375,
	"./flags/BS.svg": 376,
	"./flags/BT.svg": 377,
	"./flags/BV.svg": 378,
	"./flags/BW.svg": 379,
	"./flags/BY.svg": 380,
	"./flags/BZ.svg": 381,
	"./flags/CA.svg": 382,
	"./flags/CC.svg": 383,
	"./flags/CD.svg": 384,
	"./flags/CF.svg": 385,
	"./flags/CG.svg": 386,
	"./flags/CH.svg": 387,
	"./flags/CI.svg": 388,
	"./flags/CK.svg": 389,
	"./flags/CL.svg": 390,
	"./flags/CM.svg": 391,
	"./flags/CN.svg": 392,
	"./flags/CO.svg": 393,
	"./flags/CR.svg": 394,
	"./flags/CU.svg": 395,
	"./flags/CV.svg": 396,
	"./flags/CW.svg": 397,
	"./flags/CX.svg": 398,
	"./flags/CY.svg": 399,
	"./flags/CZ.svg": 400,
	"./flags/DE.svg": 401,
	"./flags/DJ.svg": 402,
	"./flags/DK.svg": 403,
	"./flags/DM.svg": 404,
	"./flags/DO.svg": 405,
	"./flags/DZ.svg": 406,
	"./flags/EC.svg": 407,
	"./flags/EE.svg": 408,
	"./flags/EG.svg": 409,
	"./flags/ER.svg": 410,
	"./flags/ES.svg": 411,
	"./flags/ET.svg": 412,
	"./flags/EU.svg": 413,
	"./flags/FI.svg": 414,
	"./flags/FJ.svg": 415,
	"./flags/FK.svg": 416,
	"./flags/FM.svg": 417,
	"./flags/FO.svg": 418,
	"./flags/FR.svg": 419,
	"./flags/GA.svg": 420,
	"./flags/GB-ENG.svg": 421,
	"./flags/GB-NIR.svg": 422,
	"./flags/GB-SCT.svg": 423,
	"./flags/GB-WLS.svg": 424,
	"./flags/GB-ZET.svg": 425,
	"./flags/GB.svg": 426,
	"./flags/GD.svg": 427,
	"./flags/GE.svg": 428,
	"./flags/GF.svg": 429,
	"./flags/GG.svg": 430,
	"./flags/GH.svg": 431,
	"./flags/GI.svg": 432,
	"./flags/GL.svg": 433,
	"./flags/GM.svg": 434,
	"./flags/GN.svg": 435,
	"./flags/GP.svg": 436,
	"./flags/GQ.svg": 437,
	"./flags/GR.svg": 438,
	"./flags/GS.svg": 439,
	"./flags/GT.svg": 440,
	"./flags/GU.svg": 441,
	"./flags/GW.svg": 442,
	"./flags/GY.svg": 443,
	"./flags/HK.svg": 444,
	"./flags/HM.svg": 445,
	"./flags/HN.svg": 446,
	"./flags/HR.svg": 447,
	"./flags/HT.svg": 448,
	"./flags/HU.svg": 449,
	"./flags/ID.svg": 450,
	"./flags/IE.svg": 451,
	"./flags/IL.svg": 452,
	"./flags/IM.svg": 453,
	"./flags/IN.svg": 454,
	"./flags/IO.svg": 455,
	"./flags/IQ.svg": 456,
	"./flags/IR.svg": 457,
	"./flags/IS.svg": 458,
	"./flags/IT.svg": 459,
	"./flags/JE.svg": 460,
	"./flags/JM.svg": 461,
	"./flags/JO.svg": 462,
	"./flags/JP.svg": 463,
	"./flags/KE.svg": 464,
	"./flags/KG.svg": 465,
	"./flags/KH.svg": 466,
	"./flags/KI.svg": 467,
	"./flags/KM.svg": 468,
	"./flags/KN.svg": 469,
	"./flags/KP.svg": 470,
	"./flags/KR.svg": 471,
	"./flags/KW.svg": 472,
	"./flags/KY.svg": 473,
	"./flags/KZ.svg": 474,
	"./flags/LA.svg": 475,
	"./flags/LB.svg": 476,
	"./flags/LC.svg": 477,
	"./flags/LGBT.svg": 478,
	"./flags/LI.svg": 479,
	"./flags/LK.svg": 480,
	"./flags/LR.svg": 481,
	"./flags/LS.svg": 482,
	"./flags/LT.svg": 483,
	"./flags/LU.svg": 484,
	"./flags/LV.svg": 485,
	"./flags/LY.svg": 486,
	"./flags/MA.svg": 487,
	"./flags/MC.svg": 488,
	"./flags/MD.svg": 489,
	"./flags/ME.svg": 490,
	"./flags/MF.svg": 491,
	"./flags/MG.svg": 492,
	"./flags/MH.svg": 493,
	"./flags/MK.svg": 494,
	"./flags/ML.svg": 495,
	"./flags/MM.svg": 496,
	"./flags/MN.svg": 497,
	"./flags/MO.svg": 498,
	"./flags/MP.svg": 499,
	"./flags/MQ.svg": 500,
	"./flags/MR.svg": 501,
	"./flags/MS.svg": 502,
	"./flags/MT.svg": 503,
	"./flags/MU.svg": 504,
	"./flags/MV.svg": 505,
	"./flags/MW.svg": 506,
	"./flags/MX.svg": 507,
	"./flags/MY.svg": 508,
	"./flags/MZ.svg": 509,
	"./flags/NA.svg": 510,
	"./flags/NC.svg": 511,
	"./flags/NE.svg": 512,
	"./flags/NF.svg": 513,
	"./flags/NG.svg": 514,
	"./flags/NI.svg": 515,
	"./flags/NL.svg": 516,
	"./flags/NO.svg": 517,
	"./flags/NP.svg": 518,
	"./flags/NR.svg": 519,
	"./flags/NU.svg": 520,
	"./flags/NZ.svg": 521,
	"./flags/OM.svg": 522,
	"./flags/PA.svg": 523,
	"./flags/PE.svg": 524,
	"./flags/PF.svg": 525,
	"./flags/PG.svg": 526,
	"./flags/PH.svg": 527,
	"./flags/PK.svg": 528,
	"./flags/PL.svg": 529,
	"./flags/PM.svg": 530,
	"./flags/PN.svg": 531,
	"./flags/PR.svg": 532,
	"./flags/PS.svg": 533,
	"./flags/PT.svg": 534,
	"./flags/PW.svg": 535,
	"./flags/PY.svg": 536,
	"./flags/QA.svg": 537,
	"./flags/RE.svg": 538,
	"./flags/RO.svg": 539,
	"./flags/RS.svg": 540,
	"./flags/RU.svg": 541,
	"./flags/RW.svg": 542,
	"./flags/SA.svg": 543,
	"./flags/SB.svg": 544,
	"./flags/SC.svg": 545,
	"./flags/SD.svg": 546,
	"./flags/SE.svg": 547,
	"./flags/SG.svg": 548,
	"./flags/SH.svg": 549,
	"./flags/SI.svg": 550,
	"./flags/SJ.svg": 551,
	"./flags/SK.svg": 552,
	"./flags/SL.svg": 553,
	"./flags/SM.svg": 554,
	"./flags/SN.svg": 555,
	"./flags/SO.svg": 556,
	"./flags/SR.svg": 557,
	"./flags/SS.svg": 558,
	"./flags/ST.svg": 559,
	"./flags/SV.svg": 560,
	"./flags/SX.svg": 561,
	"./flags/SY.svg": 562,
	"./flags/SZ.svg": 563,
	"./flags/TC.svg": 564,
	"./flags/TD.svg": 565,
	"./flags/TF.svg": 566,
	"./flags/TG.svg": 567,
	"./flags/TH.svg": 568,
	"./flags/TJ.svg": 569,
	"./flags/TK.svg": 570,
	"./flags/TL.svg": 571,
	"./flags/TM.svg": 572,
	"./flags/TN.svg": 573,
	"./flags/TO.svg": 574,
	"./flags/TR.svg": 575,
	"./flags/TT.svg": 576,
	"./flags/TV.svg": 577,
	"./flags/TW.svg": 578,
	"./flags/TZ.svg": 579,
	"./flags/UA.svg": 580,
	"./flags/UG.svg": 581,
	"./flags/UM.svg": 582,
	"./flags/US-CA.svg": 583,
	"./flags/US.svg": 584,
	"./flags/UY.svg": 585,
	"./flags/UZ.svg": 586,
	"./flags/VA.svg": 587,
	"./flags/VC.svg": 588,
	"./flags/VE.svg": 589,
	"./flags/VG.svg": 590,
	"./flags/VI.svg": 591,
	"./flags/VN.svg": 592,
	"./flags/VU.svg": 593,
	"./flags/WF.svg": 594,
	"./flags/WS.svg": 595,
	"./flags/XK.svg": 596,
	"./flags/YE.svg": 597,
	"./flags/YT.svg": 598,
	"./flags/ZA.svg": 599,
	"./flags/ZM.svg": 600,
	"./flags/ZW.svg": 601,
	"./howTo__bg.png": 1653,
	"./howTo__numberLine--bottom.png": 1654,
	"./howTo__numberLine--top.png": 1655,
	"./iconAccount.png": 1656,
	"./iconArrowDown.png": 1657,
	"./iconArrowLeft.png": 1658,
	"./iconArrowRight.png": 1659,
	"./iconArrowUp.png": 1660,
	"./iconClipboard.png": 1661,
	"./iconClose.png": 1662,
	"./iconEdit.png": 1663,
	"./iconInfoCircle--red.png": 1664,
	"./iconInfoCircle.png": 1665,
	"./iconLoading.png": 1666,
	"./iconLock.png": 1667,
	"./iconNavMenu.png": 1668,
	"./iconNotification--red.png": 1669,
	"./iconNotification.png": 1670,
	"./iconPaginateFirst.png": 1671,
	"./iconPaginateLast.png": 1672,
	"./iconPaginateNext.png": 1673,
	"./iconPaginatePrev.png": 1674,
	"./iconPlus.png": 1675,
	"./iconSquadBet__check.png": 1676,
	"./iconSquadBet__edit.png": 1677,
	"./iconSquadBet__pickArrow.png": 1678,
	"./iconSquadBet__plus.png": 1679,
	"./iconSquadBet__sub.png": 1680,
	"./iconSquadBet__tieBreaker.png": 1681,
	"./iconTrash.png": 1682,
	"./iconTrend--down.png": 1683,
	"./iconTrend--same.png": 1684,
	"./iconTrend--up.png": 1685,
	"./icon__arrow-left.png": 1686,
	"./icon__arrow-right.png": 1687,
	"./icon__backArrow--lightGray.svg": 1688,
	"./icon__backArrow.svg": 1689,
	"./icon__betPick--censored.png": 1690,
	"./icon__betPick--none.png": 1691,
	"./icon__betPick--pick.png": 1692,
	"./icon__burger-menu.png": 1693,
	"./icon__checkmark.png": 1694,
	"./icon__clear.png": 1695,
	"./icon__close.png": 1696,
	"./icon__copy-to-clipboard.png": 1697,
	"./icon__deleteMember.png": 1698,
	"./icon__editMember.png": 1699,
	"./icon__editProfile.png": 1700,
	"./icon__font-awesome-plus.svg": 1701,
	"./icon__form--checkmark.png": 1702,
	"./icon__live.png": 1703,
	"./icon__locked.png": 1704,
	"./icon__paginationArrows.png": 1705,
	"./icon__plus.png": 1706,
	"./icon__point--default.png": 1707,
	"./icon__point--gained.png": 1708,
	"./icon__point--text.png": 1709,
	"./icon__profile.png": 1710,
	"./icon__search--white.png": 1711,
	"./icon__search.png": 1712,
	"./icon__sectionClosed.png": 1713,
	"./icon__sectionOpen.png": 1714,
	"./icon__socialLink.png": 1715,
	"./icon__unlocked.png": 1716,
	"./icon__warning.png": 1717,
	"./landing__bg.png": 1718,
	"./landing__eventPrize__prize1.jpg": 1719,
	"./landing__eventPrize__prize2.jpg": 1720,
	"./landing__eventPrize__prize3.jpg": 1721,
	"./landing__howToPlay__bulletPoint.png": 1722,
	"./landing__leaguesTeaser.jpg": 1723,
	"./landing__leaguesTeaser.png": 1724,
	"./landing__seasonPrize__prize1.jpg": 1725,
	"./landing__seasonPrize__prize2.jpg": 1726,
	"./landing__seasonPrize__prize3.jpg": 1727,
	"./landing__teaser__applicationImage.png": 1728,
	"./landing__teaser__bg.jpg": 1729,
	"./landing__teaser__boxDeco--desktop.png": 1730,
	"./landing__teaser__boxDeco--mobile.png": 1731,
	"./landing__teaser__scoring--mobile.png": 1732,
	"./landing__teaser__scoring.png": 1733,
	"./lineup__field.png": 1734,
	"./lineup__iconClosePopup.png": 1735,
	"./lineup__iconMarkPickedOption.png": 1736,
	"./lineup__puk.png": 1737,
	"./lineup__slot__plus.png": 1738,
	"./lineup__stat__percPicked.png": 1739,
	"./lineup__stat__prevScore.png": 1740,
	"./lineup__stat__totalScore.png": 1741,
	"./lineup__synching.png": 1742,
	"./magenta_sport_logo.svg": 1743,
	"./matchdaySelector__next.png": 1744,
	"./matchdaySelector__prev.png": 1745,
	"./nikon.svg": 1746,
	"./pageTitle__background.png": 1747,
	"./penny.svg": 1748,
	"./prizeBox__bg--desktop.jpg": 1749,
	"./prizeBox__bg--mobile.png": 1750,
	"./prizeBox__fg.png": 1751,
	"./prizes__prize--placeholder.png": 1752,
	"./prizes__prizeBg.jpg": 1753,
	"./prizes__prizeBg__deco.png": 1754,
	"./prizes__prizeFg--1.png": 1755,
	"./prizes__prizeFg--2.png": 1756,
	"./prizes__prizeFg--3.png": 1757,
	"./prizes__prizeFg--4.png": 1758,
	"./prizes__prizeFg--5.png": 1759,
	"./prizes__prizeFg--6.png": 1760,
	"./prizes__prizeFg--7.png": 1761,
	"./prizes__prizeFg--8.png": 1762,
	"./prizes__sidebar--bg.jpg": 1763,
	"./prizes__sidebar--image.png": 1764,
	"./roundSummary__titleDeco.jpg": 1765,
	"./sampleBet__deco.png": 1766,
	"./sandbox/knuckles--thumb.png": 1767,
	"./sandbox/knuckles.png": 199,
	"./sandbox/mario--thumb.png": 1768,
	"./sandbox/mario.png": 200,
	"./sandbox/megaman--thumb.png": 1769,
	"./sandbox/megaman.png": 201,
	"./sandbox/peach--thumb.png": 1770,
	"./sandbox/peach.png": 202,
	"./sandbox/sailormoon--thumb.png": 1771,
	"./sandbox/sailormoon.png": 203,
	"./sandbox/samus--thumb.png": 1772,
	"./sandbox/samus.png": 204,
	"./sandbox/sonic--thumb.png": 1773,
	"./sandbox/sonic.png": 205,
	"./scoreBet__detailScore__markCorrect--dark.png": 1774,
	"./scoreBet__detailScore__markCorrect.png": 1775,
	"./scoreBet__detailScore__markWrong--dark.png": 1776,
	"./scoreBet__detailScore__markWrong.png": 1777,
	"./scoreBet__picker__close.png": 1778,
	"./sectionBg--ranking.jpg": 1779,
	"./selectionBet__decoPickWinner.png": 1780,
	"./selectionBet__flagBg.jpg": 1781,
	"./social_svgs/facebook.svg": 1782,
	"./social_svgs/instagram.svg": 1783,
	"./social_svgs/tiktok.svg": 1784,
	"./social_svgs/x.svg": 1785,
	"./social_svgs/youtube.svg": 1786,
	"./sponsorImage.png": 1787,
	"./squadBet__iconChange.png": 1788,
	"./squadBet__iconClearSwap.png": 1789,
	"./squadBet__iconSwap.png": 1790,
	"./squadBet__iconSwapSample.png": 1791,
	"./squadBet__playerPlaceholder.png": 1792,
	"./squadBet__teamPlaceholder.png": 1793,
	"./statusPage__503.png": 1794,
	"./teams/logo__1.svg": 602,
	"./teams/logo__11.svg": 603,
	"./teams/logo__12.svg": 604,
	"./teams/logo__13.svg": 605,
	"./teams/logo__14.svg": 606,
	"./teams/logo__15.svg": 607,
	"./teams/logo__2.svg": 608,
	"./teams/logo__3.svg": 609,
	"./teams/logo__4.svg": 610,
	"./teams/logo__44.svg": 611,
	"./teams/logo__6.svg": 612,
	"./teams/logo__62.svg": 613,
	"./teams/logo__7.svg": 614,
	"./teams/logo__8.svg": 615,
	"./teams/logo__9.svg": 616,
	"./telekom--mobile.svg": 1795,
	"./telekom.png": 1796,
	"./textSelectionSample__dropdown.png": 1797,
	"./triangle--down.png": 1798,
	"./triangle--up.png": 1799,
	"./tutorialSlide__screenshot1.png": 1800,
	"./tutorialSlide__screenshot2.png": 1801,
	"./tutorialSlide__screenshot3.png": 1802,
	"./tutorialSlide__screenshot4.png": 1803,
	"./tutorialSlide__screenshot5.png": 1804,
	"./tutorialSlide__screenshot6.png": 1805,
	"./tutorialSlide__screenshot7.png": 1806,
	"./ui__arrowDown--dark.png": 1807,
	"./ui__arrowDown.png": 1808,
	"./ui__arrowDownInactive--dark.png": 1809,
	"./ui__arrowDownInactive.png": 1810,
	"./ui__arrowLeft--dark.png": 1811,
	"./ui__arrowLeft.png": 1812,
	"./ui__arrowLeftInactive--dark.png": 1813,
	"./ui__arrowLeftInactive.png": 1814,
	"./ui__arrowRight--dark.png": 1815,
	"./ui__arrowRight.png": 1816,
	"./ui__arrowRightInactive--dark.png": 1817,
	"./ui__arrowRightInactive.png": 1818,
	"./ui__arrowUp--dark.png": 1819,
	"./ui__arrowUp.png": 1820,
	"./ui__arrowUpInactive--dark.png": 1821,
	"./ui__arrowUpInactive.png": 1822,
	"./ui__backlinkArrow.svg": 1823,
	"./ui__burgerButton.svg": 1824,
	"./ui__checkArrow--dark.png": 1825,
	"./ui__checkArrow.png": 1826,
	"./ui__lockLocked--dark.png": 1827,
	"./ui__lockLocked.png": 1828,
	"./ui__lockUnlocked--dark.png": 1829,
	"./ui__lockUnlocked.png": 1830,
	"./ui__textArrowDown--dark.png": 1831,
	"./ui__textArrowDown.png": 1832,
	"./ui__textArrowUp--dark.png": 1833,
	"./ui__textArrowUp.png": 1834,
	"./ui__textCross--dark.png": 1835,
	"./ui__textCross.png": 1836,
	"./ui__themeToggleDark--dark.png": 1837,
	"./ui__themeToggleDark.png": 1838,
	"./ui__themeToggleLight--dark.png": 1839,
	"./ui__themeToggleLight.png": 1840,
	"./ui__warning--dark.png": 1841,
	"./ui__warning.png": 1842,
	"./winner--left.png": 1843,
	"./winner--right.png": 1844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;